module.exports = __webpack_public_path__ + "img/logo_cor.87e587f7.png";